// src/composables/usePolicyStatus.js
import { ref } from "vue";
import { api } from "@/services/api";

// Module-level shared state
const pendingPolicies = ref([]);
const pendingConsents = ref([]);
const checked         = ref(false);
const loading         = ref(false);

export function usePolicyStatus() {

  async function checkStatus() {
    const token = localStorage.getItem("token");

    if (!token) {
      pendingPolicies.value = [];
      pendingConsents.value = [];
      // Do NOT set checked=true — so guard always re-runs after login
      return;
    }

    loading.value = true;
    try {
      const res = await api.get("/policy/status");
      pendingPolicies.value = res.data?.pending_policies || [];
      pendingConsents.value = res.data?.pending_consents || [];
      console.log(
        "[Policy] policies:", pendingPolicies.value.length,
        "| consents:", pendingConsents.value.length
      );
    } catch (err) {
      console.warn("[Policy] failed:", err?.response?.status, err?.message);
      pendingPolicies.value = [];
      pendingConsents.value = [];
    } finally {
      loading.value = false;
      checked.value = true;
    }
  }

  // Force a fresh API call regardless of checked state
  async function recheck() {
    checked.value = false;
    await checkStatus();
  }

  // Reset after login/logout so guard re-checks on next navigation
  function reset() {
    checked.value         = false;
    pendingPolicies.value = [];
    pendingConsents.value = [];
  }

  function clearPolicy(policyType, version) {
    pendingPolicies.value = pendingPolicies.value.filter(
      p => !(p.policy_type === policyType && p.version === version)
    );
  }

  function clearConsent(consentId) {
    pendingConsents.value = pendingConsents.value.filter(
      c => c.consent_id !== consentId
    );
  }

  return {
    pendingPolicies,
    pendingConsents,
    checked,
    loading,
    checkStatus,
    recheck,
    reset,
    clearPolicy,
    clearConsent,
  };
}